/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

// import ScrollMenu from "react-horizontal-scrolling-menu";

// import { loadProgressBar } from "axios-progress-bar";
// import queryString from "query-string";

import SearchBox from '../search/SearchBox';

import ContentItem from '../../components/ContentItem';
// import InfiniteScroll from "react-infinite-scroll-component";

//import ProgressContainer from '../containers/ProgressContainer'

class ThemePartList extends Component {
  state = {
    gotoPage: 1,
    pageSize: 15,
    onOverWith: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    // const { location } = this.props;
    const themeSerial = this.props.childProps.themeSerial;
    // const { gotoPage } = this.state;
    this._isMounted = true;

    //console.log(themeSerial)

    if (
      themeSerial === null ||
      themeSerial === undefined ||
      themeSerial === ''
    ) {
    } else {
      this._getSearchData(themeSerial);
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    ////console.log(this.props.location.pathname)
    ////console.log(nextProps.location)
    return (
      this.props.childProps.themeSerial !== nextProps.childProps.themeSerial
    );
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    if (
      this.props.childProps.themeSerial !== nextProps.childProps.themeSerial
    ) {
      this._getSearchData(nextProps.childProps.themeSerial);
    }
  };
  _getSearchData = async (themeSerial) => {
    const result = await this._getSearchDataApi(themeSerial);
    const intReturn = result.data[0].intReturn;
    const searchList = result.data[0].listData;
    //console.log(searchList)
    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          searchList: searchList,
          themeSerial: themeSerial,
        });
      }
    }
  };
  _getSearchDataApi = (themeSerial) => {
    const { apiUrl, loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    }

    return axios
      .post(apiUrl + '/themePartList', {
        params: {
          userid: loginId,
          themeSerial: themeSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _renderItem = () => {
    const { searchList } = this.state;

    const list = searchList.map((item, index) => {
      return (
        <div style={{ display: 'inline-block' }}>
          <ContentItem
            refer={'search'}
            contentSerial={item.contentSerial}
            title={item.title}
            genreName={item.genreName}
            img={item.img}
            overImg={item.overImg}
            restrictionCode={item.restrictionCode}
            opening={item.opening}
            director={item.director}
            contentSysnopsis={item.contentSysnopsis}
            wishFlag={item.wishFlag}
            contentPartSerial={item.contentPartSerial}
            onChangeWidth={this._onChangeWidth}
            subTitle={item.subTitle}
          />
        </div>
      );
    });

    return list;
  };

  _onChangeWidth = (num, over) => {
    //console.log('over...')
    this.setState({
      onOverWith: over,
    });
  };
  _renderBox = () => {
    const { searchList } = this.state;

    let temp = [];

    for (let i = 0; i < searchList.length; i = i + 6) {
      temp.push(
        <SearchBox
          searchList={searchList.filter((item, index) => {
            return index >= i && index < i + 6;
          })}
          key={i}
        />
      );
    }

    const list = temp.map((item, index) => {
      return item;
    });
    return list;
  };

  render() {
    const { searchList } = this.state;
    ////console.log(searchList)
    return (
      <Fragment>
        <div className="content" style={{ position: 'relative' }}>
          <div className="vod_list_right vod_list_padding0">
            <div className="vod_list_group">
              <h1 style={{ lineHeight: 4 }}>
                {searchList ? (
                  <img
                    src={
                      'https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/theme/' +
                      searchList[0].imageS
                    }
                  />
                ) : null}{' '}
                {searchList ? searchList[0].themeTitle : null}{' '}
                <span>({searchList ? searchList.length : null})</span>
              </h1>

              <div className="vod_vod_list">
                <div className="main_list_goup1">
                  {searchList ? this._renderBox() : null}
                  {/*
                                    <div className="div_ul">
                                    <InfiniteScroll
                                        dataLength={this.state.searchList.length}
                                        next={() => this._getSearchData(gotoPage, strFind)}
                                        hasMore={ hasMore }
                                        loader={<div className="vod_loading"><img src="/img/vod/vod_loading.png"/></div>}
                                        style={{overflow: 'hidden', textAlign: 'center'}}
                                        endMessage={
                                            <p style={{textAlign: 'center'}}>
                                            
                                            </p>
                                        }
                                    >
                                    { searchList ? this._renderItem() : null}
                                    </InfiniteScroll> 
                                    </div>
                                    */}
                  <div className="clear"></div>
                </div>
                {/*<div className="vod_baner1"><img src="/img/vod/ee.png"/></div>*/}
              </div>

              {/*<div className="vod_loading"><img src="img/vod/vod_loading.png"/></div>*/}
            </div>
          </div>
          <div className="clear"></div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ThemePartList));
